import { render } from "./BaseDocCadastro.vue?vue&type=template&id=cec89350"
import script from "./BaseDocCadastro.vue?vue&type=script&lang=js"
export * from "./BaseDocCadastro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__